var map = {
	"./__tests__/lti.resourceImported.test.js": [
		"LFe7",
		4173
	],
	"./__tests__/lti.screenReaderAlert.test.js": [
		"0Guc",
		4174
	],
	"./__tests__/lti.showAlert.test.js": [
		"+y7l",
		4175
	],
	"./__tests__/org.imsglobal.lti.get_data.test.js": [
		"CXUv",
		4161
	],
	"./__tests__/org.imsglobal.lti.put_data.test.js": [
		"mElt",
		4162
	],
	"./__tests__/requestFullWindowLaunch.test.js": [
		"o6ta",
		4176
	],
	"./lti.enableScrollEvents.js": [
		"HVU3",
		4233
	],
	"./lti.fetchWindowSize.js": [
		"OANa",
		4234
	],
	"./lti.frameResize.js": [
		"bSyB",
		4163
	],
	"./lti.hideRightSideWrapper.js": [
		"ozOx",
		4235
	],
	"./lti.removeUnloadMessage.js": [
		"tjuu",
		4177
	],
	"./lti.resourceImported.js": [
		"FC2N",
		4236
	],
	"./lti.screenReaderAlert.js": [
		"YYEg",
		4237
	],
	"./lti.scrollToTop.js": [
		"W/R1",
		4238
	],
	"./lti.setUnloadMessage.js": [
		"6fDN",
		4178
	],
	"./lti.showAlert.js": [
		"onLg",
		4239
	],
	"./lti.showModuleNavigation.js": [
		"NSTA",
		4240
	],
	"./org.imsglobal.lti.capabilities.js": [
		"zPPZ",
		4241
	],
	"./org.imsglobal.lti.get_data.js": [
		"lH2A",
		4171
	],
	"./org.imsglobal.lti.put_data.js": [
		"hugc",
		4172
	],
	"./requestFullWindowLaunch.js": [
		"8IHO",
		4242
	],
	"./toggleCourseNavigationMenu.js": [
		"ECMy",
		4243
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "G4i8";
module.exports = webpackAsyncContext;